// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navItem__fl_sG {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-transform: uppercase;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  color: #c7cddd;
  text-decoration: none;
}
.navItem__fl_sG svg {
  opacity: 0.7;
  width: 32px;
  height: 32px;
}
.navItem__fl_sG:hover .textContainer__pQXjr {
  color: #FFFFFF;
}
.navItem__fl_sG:hover svg {
  opacity: 1;
}
@media (max-width: 850px) {
  .navItem__fl_sG {
    font-size: 11px;
  }
  .navItem__fl_sG svg {
    width: 24px;
    height: 24px;
  }
}

.closedSidebarNavItem__Z8gwH {
  justify-content: center;
}

.textContainer__pQXjr {
  width: 120px;
  padding-left: 10px;
}
@media (max-width: 850px) {
  .textContainer__pQXjr {
    width: 110px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/NavButtonItem/style.module.scss","webpack://./../src/assets/variables.scss"],"names":[],"mappings":"AA4EA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AA3EF;AA6EE;EACE,YAAA;EACA,WAAA;EACA,YAAA;AA3EJ;AA+EI;EACE,cCjGE;ADoBR;AAgFI;EACE,UAAA;AA9EN;AAkFE;EA9BF;IA+BI,eAAA;EA/EF;EAiFE;IACE,WAAA;IACA,YAAA;EA/EJ;AACF;;AAmFA;EACE,uBAAA;AAhFF;;AAmFA;EACE,YAAA;EACA,kBAAA;AAhFF;AAkFE;EAJF;IAKI,YAAA;EA/EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.navItem {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-transform: uppercase;\n  position: relative;\n  cursor: pointer;\n  margin-bottom: 15px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 12px;\n  color: #c7cddd;\n  text-decoration: none;\n\n  svg {\n    opacity: 0.7;\n    width: 32px;\n    height: 32px;\n  }\n\n  &:hover {\n    .textContainer {\n      color: $white;\n    }\n\n    svg {\n      opacity: 1;\n    }\n  }\n\n  @media (max-width: 850px) {\n    font-size: 11px;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n.closedSidebarNavItem {\n  justify-content: center;\n}\n\n.textContainer {\n  width: 120px;\n  padding-left: 10px;\n\n  @media (max-width: 850px) {\n    width: 110px;\n  }\n}\n","$black: #000000;\n$white: #FFFFFF;\n$white-1: #F2F4F9;\n$white-2: #D0D6E5;\n$turquoise: #3697AB;\n$blue-1: #82C6D4;\n$blue-2: #D5EBEF;\n$red-1: #B92C2C;\n$red-2: #FFCFCF;\n$green-1: #12ac6c;\n$green-2: #66C890;\n$green-3: #DDEFD5;\n$green-4: #3DE0A1;\n$orange-1: #F48E62;\n$orange-2: #FEB805;\n$yellow-1: #F4DA62;\n$yellow-2: #FFECAA;\n$dark-blue-1: #13161F;\n$dark-blue-2: #232732;\n$gray-1: #494D5B;\n$gray-2: #747A8E;\n$gray-3: #A6A6A6;\n$gray-4: #6F7B87;\n\n$yellow-0: #F4D115;\n$yellow: #F8C71C;\n$red-0: #F82D46;\n$red: #F24F52;\n$green-0: #42AD7E;\n$orange-0: #F9845A;\n$gray-0: #75899D;\n$blue-0: #3C97AA;\n$blue: #17B5D6;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navItem": `navItem__fl_sG`,
	"textContainer": `textContainer__pQXjr`,
	"closedSidebarNavItem": `closedSidebarNavItem__Z8gwH`
};
module.exports = ___CSS_LOADER_EXPORT___;
